import { CourseAccessSection } from "./CourseAccessSection";
import { GeneralSection } from "./GeneralSection";

interface CourseFlowProps {
  currentSpaceGroupId?: number;
  onImageProcessing: (isProcessing: boolean) => void;
}

export const CourseFlow = ({
  currentSpaceGroupId,
  onImageProcessing,
}: CourseFlowProps) => (
  <div className="flex flex-col gap-y-4">
    <GeneralSection
      currentSpaceGroupId={currentSpaceGroupId}
      onImageProcessing={onImageProcessing}
    />
    <CourseAccessSection />
  </div>
);
